export default __webpack_public_path__ + "static/media/cq.0fc36334.svg";